<template>
  <hm-content title="">
    <div>
      <div class="temp-header flex flex-between">
        <div @click="back" class="btn">
          <span class="hmicon icon-fanhui"></span>
          返回
        </div>
        <div class="flex flex-end">
          <div v-if="provinceName" class="mr10">
            当前省份: <span class="primary">{{ provinceName }}</span>
          </div>
          <div v-if="sh">
            当前商户: <span class="primary">{{ sh }}</span>
          </div>
        </div>
      </div>
      <div class="tabbar">
        <el-radio-group
          v-model="status"
          size="small"
          @change="switchTab"
          class="ml20"
          style="marginLeft:50px;"
        >
          <el-radio-button label="receipt">小票图片</el-radio-button>
          <el-radio-button label="waitList" v-if="sh"
            >待审核列表</el-radio-button
          >
        </el-radio-group>
      </div>

      <div class="p20 flex flex-warp">
        <div class="ml10 wb20">
          <div class="title">
            OCR识别结果
          </div>
          <div class="ocr scrollocr">
            <div
              v-for="(v, i) in detailsSalesVolume.ocrResultList"
              :key="i"
              class="mb10 pointer"
              @click="getInfo(v)"
            >
              {{ v }}
            </div>
          </div>
        </div>

        <div class="mr10 mt10 ml10 flex-1" style="width:55%">
          <div class="flex flex-center mb20">
            <div class="flex-1">
              导购姓名：<span>{{ detailsSalesVolume.guiderName }}</span>
            </div>
            <div class="flex-1">电话：{{ detailsSalesVolume.guiderPhone }}</div>
            <div class="flex-1 flex item-center">
              申报单号：
              {{ detailsSalesVolume.declareSn }}
            </div>
            <!-- <div class="flex-1">
              所属商户：
              {{ detailsSalesVolume.storeName }}
            </div> -->

            <!-- <div class="flex-1">
              申报单号：{{ detailsSalesVolume.declareSn }}
            </div>
            <div class="flex-1">
              小票号：<el-input
                v-model="detailsSalesVolume.receiptSn"
                clearable
                placeholder="请填写小票号"
                size="small"
                class="ipt"
              ></el-input>
            </div> -->
          </div>
          <div class="flex flex-center mb20">
            <!-- <div class="flex-1">
              所属门店商：
              {{ detailsSalesVolume.storeName }}
            </div>
            <div class="flex-1">
              所属门店：
              <span class="blue"> {{ detailsSalesVolume.shopName }}</span>
            </div> -->
            <!-- <div class="flex-1">
              申报日期：
              {{ detailsSalesVolume.declareTime }}
            </div> -->
            <div class="flex-1 flex item-center">
              <span
                :class="[
                  detailsSalesVolume.storeNameOcrFlag ? 'success' : 'danger'
                ]"
                >所属门店：</span
              >
              <span> {{ detailsSalesVolume.shopName }}</span>
            </div>
            <div class="flex-1 flex item-center">
              <span
                style="width:56px"
                :class="[
                  detailsSalesVolume.receiptSnOcrFlag ? 'success' : 'danger'
                ]"
                >小票号：</span
              >
              <el-input
                v-model="detailsSalesVolume.receiptSn"
                clearable
                style="width:200px"
                placeholder="请填写小票号"
                size="small"
                class="ipt"
              ></el-input>
            </div>
          </div>
          <div class="flex-1 flex item-center mb10">
            <div class="flex-1 flex item-center">
              <span
                :class="[
                  detailsSalesVolume.receiptDateOcrFlag ? 'success' : 'danger'
                ]"
              >
                小票日期：</span
              >
              {{ detailsSalesVolume.receiptDate }}
            </div>
            <div
              class="flex-1 flex item-center"
              v-if="personAuditState === 'agree'"
            >
              当前状态: <span class="success">已通过</span>
            </div>
            <div
              class="flex-1 flex item-center"
              v-if="personAuditState === 'refuse'"
            >
              当前状态: <span class="danger">已驳回</span>
            </div>
            <div
              class="flex-1 flex item-center"
              v-if="personAuditState === 'hang'"
            >
              当前状态: <span class="danger">挂单</span>
            </div>
            <div
              class="flex-1 flex item-center"
              v-if="personAuditState === 'wait'"
            >
              当前状态: <span class="gray">待审核</span>
            </div>
          </div>

          <div class="img-list mb20">
            <!-- <el-popover
            placement="right"
            trigger="hover"
            v-for="(v, i) in detailsSalesVolume.srcList"
            :key="i"
          >
            <img :src="v" style="width: 500px" />
            <img :src="v" :alt="v" style="width: 86px; height: 86px" />
          </el-popover> -->
            <el-image
              style="width: 86px; height: 86px;borderRadius:6px;"
              class="ml10"
              v-for="(v, i) in detailsSalesVolume.srcList"
              :key="i"
              :src="v"
              :preview-src-list="[detailsSalesVolume.srcList[i]]"
            ></el-image>
            <!-- <el-image
          style="width: 100px; height: 100px"
          src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"
          :preview-src-list="detailsSalesVolume.srcList"
        ></el-image> -->
          </div>
          <el-table
            class="mb20"
            border
            :data="detailsSalesVolume.billDetailsBoList"
            stripe
            highlight-current-row
            :row-class-name="handleCurrentChange"
            @row-click="onRowClick"
            style="width: 100%"
          >
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
            ></el-table-column>
            <el-table-column
              prop="brandName"
              label="商品品牌"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="goodsName"
              label="商品名称"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <div
                  :class="[
                    detailsSalesVolume.spuNameOcrFlag ? 'success' : 'danger'
                  ]"
                >
                  {{ scope.row.goodsName }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="goodsBarcode"
              label="商品条码"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="ocrGoodsName"
              label="匹配OCR商品名称"
              header-align="center"
              align="center"
              width="200"
            >
              <template slot-scope="scope">
                <div class="flex flex-center">
                  <el-input
                    v-model="scope.row.ocrGoodsName"
                    clearable
                    style="width:180px;"
                    placeholder="请填写匹配OCR商品名称"
                    size="small"
                    class="ipt"
                  ></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="goodsNum"
              label="销售商品数量"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <div
                  :class="[
                    detailsSalesVolume.spuNumberOcrFlag ? 'success' : 'danger'
                  ]"
                >
                  {{ scope.row.goodsNum }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="提成基数"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <div>
                  {{
                    (scope.row.redpackageMoney / scope.row.goodsNum).toFixed(2)
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="redpackageMoney"
              label="计算提成"
              header-align="center"
              align="center"
              ><template slot-scope="scope">
                <div class="primary">¥{{ scope.row.redpackageMoney }}</div>
              </template>
            </el-table-column>
          </el-table>
          <div class="flex flex-end mb20">
            <span style="fontSize:18px;fontWeight:600;"> 总计提成：</span>
            <span style="fontSize:18px;fontWeight:600;" class="primary">
              ¥{{ detailsSalesVolume.total }}</span
            >
          </div>

          <div
            class="btn-wrapper flex flex-center"
            v-if="personAuditState === 'wait' || personAuditState === 'hang'"
          >
            <el-button
              @click="submitRuleForm"
              size="small"
              type="success"
              ref="btn"
              style="width:200px;height:100px;fontSize: 35px;"
              >同意申报</el-button
            >
            <el-button
              @click="reject"
              size="small"
              type="danger"
              style="width:200px;height:100px;fontSize: 35px;"
              >驳回申报</el-button
            >
          </div>
        </div>
        <div class=" mr10" style="width:30%" v-show="status === 'receipt'">
          <div class="scrollocr receiptimg">
            <el-image
              lazy
              style="width:100%;borderRadius:6px;"
              class="ml10"
              v-for="(v, i) in detailsSalesVolume.srcList"
              :key="i"
              :src="v"
              :preview-src-list="[detailsSalesVolume.srcList[i]]"
            ></el-image>
          </div>
        </div>
        <div class=" mr10" style="width:30%" v-show="status === 'waitList'">
          <div class="title">
            待审核
          </div>

          <el-table
            class="mb20"
            border
            :data="declareList.records"
            stripe
            ref="multipleTable"
            @row-click="openDetails"
            :row-class-name="tableRowClassName"
            highlight-current-row
            style="width: 100%"
          >
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              :index="index => index + (currentPage - 1) * pageSize + 1"
            ></el-table-column>
            <el-table-column
              prop="guiderName"
              label="导购姓名"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="declareSn"
              label="申报单号"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="declareTime"
              label="申报时间"
              header-align="center"
              align="center"
            ></el-table-column>

            <el-table-column
              prop="redpackageMoney"
              label="预估收益"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <span class="primary">￥{{ scope.row.redpackageMoney }}</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="ocr-pagination hm-pagination">
            <el-pagination
              background
              :total="declareList.total"
              @current-change="paging"
              @size-change="handleSizeChange"
              layout="total,sizes,  prev, pager, next"
              :current-page="currentPage"
              :pagerCount="3"
            ></el-pagination>
          </div>
        </div>
      </div>
      <el-dialog
        title="驳回备注"
        :visible.sync="detailsVisible"
        @close="detailsVisible = false"
        custom-class="sales-volumn-dialog"
      >
        <el-form
          label-width="80px"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
        >
          <el-form-item label="驳回原因" prop="refuseReason">
            <el-input
              maxlength="100"
              placeholder="请输入驳回原因，可直接选择下方模板"
              size="small"
              style="width: auto"
              :autosize="{ minRows: 4 }"
              type="textarea"
              v-model="ruleForm.refuseReason"
            ></el-input>
          </el-form-item>
          <div class="reject-refuseReason">
            <el-radio-group v-model="rejectReason" @change="switchRejectReason">
              <div v-for="(v, i) in rejectTemp" :key="i">
                <el-radio :label="i">{{ v }}</el-radio>
              </div>
            </el-radio-group>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer flex flex-center">
          <el-button
            @click="submitReject('ruleForm')"
            size="small"
            type="primary"
            >确认</el-button
          >
          <el-button @click="detailsVisible = false" size="small"
            >关闭</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        title="警告提示"
        :visible="dangerVisible"
        @close="dangerVisible = false"
        custom-class="sales-volumn-dialog"
      >
        <div class="danger">
          {{ msg }}
        </div>
        <div class="primary">
          该订单已挂起,请确认供货商余额充足后处理!!
        </div>
      </el-dialog>
    </div>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  data() {
    return {
      provinceName: "",
      msg: "",
      dangerVisible: false,
      status: "receipt",
      detailsVisible: false,
      srcList: [],
      currentPage: 1,
      pageSize: 10,
      rejectReason: "",
      personAuditState: "",
      ruleForm: {
        refuseReason: ""
      },
      rules: {
        refuseReason: {
          required: true,
          message: "请输入驳回原因",
          trigger: "change"
        }
      },
      rejectTemp: [
        "您输入的申报数量与实际数量不符，如有疑问请联系客服。",
        "您输入的申报商品数量存在问题，如有疑问请联系客服。",
        "您小票存在问题，如有疑问请联系客服。"
      ],
      sh: "",
      key: 0
    };
  },
  computed: {
    ...mapGetters(["detailsSalesVolume", "declareList"])
  },
  watch: {},
  created() {
    document.addEventListener("keydown", this.watchEnter);
  },
  mounted() {
    this.queryAuditTemplate();
    if (this.$route.query.declareSn) {
      this.detail(this.$route.query.declareSn);
    } else {
      this.provinceName = localStorage.getItem("provinceName");
      this.sh = localStorage.getItem("sh");
      this.detail();
      this.queryDeclareList();
    }
  },
  destroyed() {
    document.removeEventListener("keydown", this.watchEnter);
  },
  methods: {
    async queryAuditTemplate() {
      const { result } = await this.$store.dispatch("queryAuditTemplate");
      this.rejectTemp = result.textContentZhCn.split("|");
    },
    handleCurrentChange({ row, rowIndex }) {
      row.index = rowIndex;
      if (row.index === this.key) {
        return "success-row";
      }

      return "";
    },
    onRowClick(row) {
      this.key = row.index;
    },
    getInfo(v) {
      this.detailsSalesVolume.billDetailsBoList[this.key].ocrGoodsName = v;
    },
    watchEnter(e) {
      var keyNum = window.event ? e.keyCode : e.which;

      if (keyNum == 13) {
        this.submitRuleForm();
      }
    },
    switchTab() {},
    tableRowClassName({ row }) {
      if (row.declareSn === this.detailsSalesVolume.declareSn) {
        return "success-row";
      }
      // if (rowIndex === 1) {
      //   return "warning-row";
      // } else if (rowIndex === 3) {
      //   ;
      // }
      return "";
    },
    detail(declareSn) {
      if (this.$route.query.declareSn) {
        return this.$store
          .dispatch("detailsSalesVolumeList", {
            declareSn: declareSn
          })
          .then(res => {
            this.personAuditState = res.result.personAuditState;
          });
      } else {
        return this.$store
          .dispatch("detailsSalesVolumeList", {
            storeCode: this.$route.query.storeCode,
            declareSn: declareSn
          })
          .then(res => {
            this.personAuditState = res.result.personAuditState;
            if (res.code === "0" && res.result === "-1") {
              this.$message({
                message: "审核完毕,返回上一页!",
                type: "success"
              });
              setTimeout(() => {
                this.$router.back(-1);
              }, 2000);
            }
          });
      }
    },
    queryDeclareList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        storeCode: this.$route.query.storeCode,
        auditState: "PCWait"
      };

      // const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      // searchCondition.declareStartTime =
      //   this.searchCondition.applyDate &&
      //   this.searchCondition.applyDate.length > 0
      //     ? this.searchCondition.applyDate[0]
      //     : "";
      // searchCondition.declareEndTime =
      //   this.searchCondition.applyDate &&
      //   this.searchCondition.applyDate.length > 0
      //     ? this.searchCondition.applyDate[1]
      //     : "";
      // Object.assign(params, searchCondition);
      return this.$store.dispatch("queryDeclareList", params);
    },
    paging(page) {
      this.currentPage = page;
      this.queryDeclareList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryDeclareList();
    },
    resetRuleForm() {
      this.$refs.ruleForm.resetFields();
      this.ruleForm.personAuditState = "";
      this.rejectReason = "";
    },
    switchRejectReason() {
      this.ruleForm.refuseReason = this.rejectTemp[this.rejectReason];
    },

    async submitRuleForm() {
      this.$refs.btn.$el.onkeydown = e => {
        let _key = window.event.keyCode;
        if (_key === 13) {
          return false;
        }
      };

      this.ruleForm.personAuditState = "agree";
      Object.assign(this.detailsSalesVolume, this.ruleForm);
      if (
        this.detailsSalesVolume.receiptSn === "" ||
        this.detailsSalesVolume.receiptSn === null
      ) {
        this.$message({
          message: "请小票号!",
          type: "warning"
        });
      } else {
        document.removeEventListener("keydown", this.watchEnter);
        const { code, inMsg, errMsg } = await this.$store.dispatch(
          "rejectSalesVolumeList",
          this.detailsSalesVolume
        );

        if (code === "0") {
          if (this.$route.query.declareSn) {
            this.$router.back(-1);
          }
          if (inMsg !== "-1") {
            this.detailsVisible = false;
            this.$message({
              message: "操作成功!",
              type: "success"
            });
            setTimeout(() => {
              this.resetRuleForm();
              // document.addEventListener("keydown", this.watchEnter);
            }, 0);
          } else {
            this.dangerVisible = true;
            this.msg = errMsg;
          }
          this.detail();
          this.queryDeclareList();
        }
        setTimeout(() => {
          document.addEventListener("keydown", this.watchEnter);
        }, 2000);
        // document.addEventListener("keydown", this.watchEnter);
        // .then(res => {
        //   if (res.code === "0") {
        //     this.detailsVisible = false;
        //     this.$message({
        //       message: "操作成功!",
        //       type: "success"
        //     });
        //     setTimeout(() => {
        //       this.resetRuleForm();
        //     }, 0);
        //     this.detail();
        //     this.queryDeclareList();
        //   } else if (res.code === "-1.1") {
        //     this.dangerVisible = true;
        //     this.msg = res.errMsg;
        //     this.detail();
        //     this.queryDeclareList();
        //   }
        // });
      }
    },
    submitReject(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.ruleForm.personAuditState = "refuse";
          Object.assign(this.detailsSalesVolume, this.ruleForm);
          this.$store
            .dispatch("rejectSalesVolumeList", this.detailsSalesVolume)
            .then(res => {
              if (res.code === "0") {
                this.detailsVisible = false;
                this.$message({
                  message: "操作成功!",
                  type: "success"
                });
                if (this.$route.query.declareSn) {
                  this.$router.back(-1);
                } else {
                  setTimeout(() => {
                    this.resetRuleForm();
                  }, 0);
                  this.detail();
                  this.queryDeclareList();
                }
              }
            });
        } else {
          return false;
        }
      });
    },
    reject() {
      this.detailsVisible = true;
    },
    openDetails(row) {
      this.detail(row.declareSn);
    },
    back() {
      if (this.$route.query.storeCode) {
        sessionStorage.removeItem("Author");
      }
      this.$router.back(-1);
    }
  }
};
</script>
<style lang="scss">
.ocr-pagination {
  .el-select {
    width: 90px;
  }
}
.el-table .success-row {
  background: #fce6f0;
}

.scrollocr::-webkit-scrollbar {
  width: 10px;
  height: 1px;
}
.scrollocr::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #535353;
}
.scrollocr::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
}
</style>
<style lang="scss" scoped>
.wb20 {
  width: 20%;
}
.tabbar {
  margin-left: 70%;
}
.receiptimg {
  height: 600px;
  -webkit-overflow-scrolling: touch;
  overflow-y: scroll;
}
.ocr {
  background: rgba(255, 249, 252, 1);
  border: 1px solid rgba(229, 0, 101, 1);
  border-radius: 6px;
  height: 500px;
  -webkit-overflow-scrolling: touch;
  overflow-y: scroll;
}
.title {
  margin-bottom: 10px;
  &::before {
    display: inline-block;
    margin-right: 10px;
    content: "";
    width: 4px;
    height: 12px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}
.temp-header {
  height: 50px;
  line-height: 50px;
  background: rgba(255, 255, 255, 1);
  color: #000;
  padding: 0 22px;
  font-size: 16px;
  user-select: none;
  .hmicon {
    color: #e50065;
    font-size: 18px;
  }
  .btn {
    cursor: pointer;
  }
  .title {
    font-size: 18px;
  }
  .sub-title {
    font-size: 14px;
  }
  .header-list {
    li {
      border-right: 1px solid #fff;
      padding: 0 22px;
    }
    li:last-child {
      padding-right: 0;
      border-right: 0;
    }
  }
}
</style>
